import { Component, OnInit } from '@angular/core';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { ModuleType } from '@fi-shared/types';
import { StatisticService } from '@fi-shared/statistic/statistic.service';

@Component({
    selector: 'fi-customer-billing-invoice-list-state',
    template: ` <fi-customer-billing-invoice-list> </fi-customer-billing-invoice-list> `,
    standalone: false,
})
export class CustomerBillingInvoiceListStateComponent implements OnInit {
    constructor(
        private tabsModuleService: TabsModuleService,
        private statisticService: StatisticService,
    ) {}

    ngOnInit(): void {
        this.statisticService.Visit(ModuleType.Billing);
    }
}
